// 9 bloques del Business Model Canvas (Alexander Osterwalder)
export const SECTIONS = [
  'Segmentos de Clientes',
  'Propuesta de Valor',
  'Canales',
  'Relación con Clientes',
  'Fuentes de Ingresos',
  'Recursos Clave',
  'Actividades Clave',
  'Asociaciones Clave',
  'Estructura de Costos',
];

// Mapeo nombre de bloque → campo del modelo BusinessPlan
export const fieldMap = {
  'Segmentos de Clientes':  'customer_segments',
  'Propuesta de Valor':     'value_proposition',
  'Canales':                'channels',
  'Relación con Clientes':  'customer_relationships',
  'Fuentes de Ingresos':    'revenue_streams',
  'Recursos Clave':         'key_resources',
  'Actividades Clave':      'key_activities',
  'Asociaciones Clave':     'key_partners',
  'Estructura de Costos':   'cost_structure',
};

// Bloques con respuesta predefinida basada en teoria BMC (sin consumo de IA).
// Deben coincidir con _PREDEFINED_BLOCKS del backend bmc_service.py
export const PREDEFINED_SECTIONS = new Set([
  'Recursos Clave',
  'Actividades Clave',
  'Asociaciones Clave',
  'Estructura de Costos',
  'Canales',
  'Relación con Clientes',
]);
